import { render, staticRenderFns } from "./ServicesModalBody.vue?vue&type=template&id=4540cba9&scoped=true"
var script = {}
import style0 from "./ServicesModalBody.vue?vue&type=style&index=0&id=4540cba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540cba9",
  null
  
)

export default component.exports